module.exports = __webpack_public_path__ + "static/media/DSC_0068.3e9fb2f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0068.jpg
// module id = 590
// module chunks = 0